// import { useFormik } from "formik";
// import {
//   BackButton,
//   CancelButton,
//   SubmitButton,
// } from "../../../../Components/Utils/Buttons";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import UseSearchDropDownNew from "../../../../../../Components/Hooks/UseSearchDropDown";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import useAddFormData from "../../../../../../Components/Hooks/useAddFormData";
import { useFormik } from "formik";
import axiosInstance from "../../../../../../Services/axiosCommon";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { BackButton, CancelButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import FormikSelectTwo, { FormikSelectWithoutAdd } from "../../../../../../Components/Utils/Select";
import { NuDate, NuInput, NuTextArea } from "../../../../../../Components/Utils/Input";
import DropDownAddMetaData from "../../../../../../Components/Utils/selectAddMetaData";
import { useNumber } from "../../../../../../Context/ProjectIdContext";
// import useAddFormData from "../../../../Components/Hooks/useAddFormData";
// import { useMemo, useState } from "react";
// import  { NuDate, NuInput,NuTextArea, } from "../../../../Components/Utils/Input";
// import FormikSelectTwo, { FormikSelectWithoutAdd } from "../../../../Components/Utils/Select";
// import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
// import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
// import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
// import axiosInstance from "../../../../Services/axiosCommon";
// import UseSearchDropDownNew from "../../../../Components/Hooks/UseSearchDropDown";
// import { useParams } from "react-router-dom";

const CreateInventory = () => {
  const {officeId,projeCtId} =useParams();
  const {number} = useNumber()

  const currentDate = new Date().toISOString().split('T')[0];
  const [search, setSearch] = useState("")  
  // const { data: grn } = UseSearchDropDownNew(`/grn/PO/drop-down/${projeCtId}`,search);
  const { data: grn } = UseSearchDropDownNew(`/grn/drop-down/${projeCtId}/project`,search);

  const {value:InventoryCondition ,getData:refInventoryCondition} = useFetchMataData(`/dropdown/dropdown-details/`,'InventoryCondition')
  const {value:StockLocation ,getData:refStockLocation} = useFetchMataData(`/dropdown/dropdown-details/`,'StockLocation')

  const { Oncancel, addFormData, isLoading } = useAddFormData();
  const [createNew, setCreateNew] = useState({
    grnId:"",
    productId:"",
    supplier: "",
    batchNo: "",
    // unit: "",
    warrentyDuration: "",
    warrentyEndDate: currentDate || "",
    condition: "",//dd?
    quantity: "",
    mfdDate: currentDate || "",
    expDate: currentDate || "",
    mrp: "",
    unitPrice: "",//need
    purchasedDate: currentDate || "",
    stockLocation: "",//dd
    minStockLevel: "",
    barcode: "",
    stockQty: "",
    adjustedQty: "",
    reasonForAdjust: "",
    warrentyApplicable: "",
    warrentyStartDate: currentDate || "",
    calibReq: "",
    calibExp: currentDate || "",
    receivedQty: "",
    issuedQty: "",
    comments: "",
    isAsset: false,
    projectId:projeCtId,

    branchId: officeId,
   
  });


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      productId: yup.string().required('Product is required!'),
      grnId: yup.string().required('GRN Reference is required!')
  
    }),
    onSubmit: async (value, { resetForm }) => {
      addFormData("/stocks/new", value, resetForm);
    },
  });

  const [grnlist, setGrnlist] = useState([]);

  function getGrn(num){
    axiosInstance.get(`/stocks/grn-products/${num}`)
    .then((response) => {
      let tempData =[]
      if(response.data.products){
        let x = response.data.products

        x.map((item) => {
        let y = {
          value: item.productId,
          label: item.product_name,
        }
        tempData.push(y)
        })
          formik.setFieldValue('supplier', response?.data?.supplier || '');

        setGrnlist(tempData)
      }
    }).catch((error) => {})
   }

   useMemo (()=>{
    if (formik.values.grnId !== '') {
      getGrn(formik.values.grnId);
    }
  }, [formik.values.grnId]);

  const handleCheckboxChange = (e) => {
    formik.setFieldValue('isAsset', e.target.checked); };

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end ">
        {/* <Breadcrumb
          items={
            [{
              name: "Inventory",
              link: `/project/store/inventory/${officeId}/${projeCtId}`
            },
            {
              name: "Create"
            }]
          }
        /> */}
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
        <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto">
              <FormikSelectWithoutAdd
              type="text"
              label="GRN"
              placeholder="Choose"
              Options={grn}
              formik={formik}
              name="grnId"
              isRequired={true}
              width="w-full md:w-1/2 lg:w-1/3"
              setSearch={setSearch}
              FixPosition={false}
              PortalTarget={false}
            />
             <FormikSelectTwo
              type="text"
              label="Product"
              placeholder="Choose"
              Options={grnlist}
              formik={formik}
              name="productId"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
                FixPosition={false}
                PortalTarget={false}
            />
            <NuInput
              type="text"
              label="Supplier"
              placeholder="Supplier"
              formik={formik}
              disabled={true}
              name="supplier"
               width="w-full md:w-1/2 lg:w-1/3"
               FixPosition={false}
               PortalTarget={false}
            />

<FormikSelectTwo
              label="Warrenty Applicable"
              placeholder="WarrentyApplicable"
              Options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              formik={formik}
              name="warrentyApplicable"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={false}
                PortalTarget={false}
            />

{formik.values.warrentyApplicable === true && (
              <NuDate
              label="Warrenty Start Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="warrentyStartDate"
                width="w-full md:w-1/2 lg:w-1/3"
            />
            )}
            {formik.values.warrentyApplicable ===true && (
              <NuDate
              label="Warrenty End Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="warrentyEndDate"
                width="w-full md:w-1/2 lg:w-1/3"
            />
            )}
            <NuInput
              type="number"
              label="Batch No"
              placeholder="Batch No"
              formik={formik}
              name="batchNo"
               width="w-full md:w-1/2 lg:w-1/3"
            />
            
            
 
             <DropDownAddMetaData
                label="Condition"
                placeholder="Choose"
                Options={InventoryCondition}
                formik={formik}
                name="condition"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refInventoryCondition}
                displayProperty={"Condition"}
                propertyName={"InventoryCondition"}
              />
            <NuDate
              label="Manufacture Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="mfdDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuDate
              label="Expiry Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="expDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              type="number"
              label="MRP"
              placeholder="MRP"
              formik={formik}
              name="mrp"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuDate
              label="Purchased Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="purchasedDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <DropDownAddMetaData
                label="Stock Location"
                placeholder="Choose"
                Options={StockLocation}
                formik={formik}
                name="stockLocation"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refStockLocation}
                displayProperty={"Stock Location"}
                propertyName={"StockLocation"}
              />
            <NuInput
              type="number"
              label="Min Stock Level"
              placeholder="Min Stock Level"
              formik={formik}
              name="minStockLevel"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              type="number"
              label="Barcode"
              placeholder="Barcode"
              formik={formik}
              name="barcode"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <NuInput
              type="number"
              label="Issued Quantity"
              placeholder="Issued Qty"
              formik={formik}
              name="issuedQty"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <NuInput
              type="number"
              label="Received Quantity"
              placeholder="Received Qty"
              formik={formik}
              name="receivedQty"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              type="number"
              label="Stock Quantity"
              placeholder="Stock Qty"
              formik={formik}
              name="stockQty"
              width="w-full md:w-1/2 lg:w-1/3"
            />

            
            <FormikSelectTwo
              label="Calibration Reqiure"
              placeholder="Choose"
              Options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              formik={formik}
              name="calibReq"
                width="w-full md:w-1/2 lg:w-1/3"
            />
            {formik.values.calibReq === true && (
              <NuDate
              label="Calibration Expiry"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="calibExp"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            )}
  <div className="flex items-center ml-7">
              <input
                type="checkbox"
                id="isAsset"
                name="isAsset"
                checked={formik.values.isAsset}
                onChange={handleCheckboxChange}
                className="mr-2"
              />
              <label htmlFor="isAsset">Asset</label>
            </div>
            <NuTextArea
              label="Comments"
              placeholder="Comments"
              formik={formik}
              name="comments"
              width="w-full md:w-1/2 lg:w-1/3"
            />
 
            <div className="w-full mx-auto my-4 mt-8 ">
              <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                <CancelButton handleClick={() => { Oncancel(-1) }} />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateInventory;
